<div class="modal-header">
  <h5 class="modal-title mb-0">{{ options().title || 'Dialog' }}</h5>
  <div class="sb-modal-header-actions">
    @if (externalUrl) {
    <a
      class="sb-modal-external"
      [href]="externalUrl"
      target="_blank"
      rel="noopener noreferrer"
      [attr.title]="options().externalLabel || 'Open in a new tab'"
      [attr.aria-label]="options().externalLabel || 'Open in a new tab'">
      <i class="fa fa-external-link" aria-hidden="true"></i>
    </a>
    }
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('cross')"></button>
  </div>
</div>

<div class="modal-body" [class.sb-modal-body--iframe]="!!safeIframeUrl">
  @if (options().bodyTemplate) {
    <ng-container *ngTemplateOutlet="options().bodyTemplate"></ng-container>
  }

  @if (!options().bodyTemplate && options().body) {
  <p class="mb-0" [innerHTML]="options().body"></p>
  }

  <div #dynamicHost></div>

  @if (safeIframeUrl) {
  <iframe
    class="sb-modal-iframe"
    [src]="safeIframeUrl"
    title="Modal content"
    frameborder="0"></iframe>
  }
</div>

@if (showFooter) {
<div class="modal-footer">
  @for (button of buttons; track button) {
  <app-sb-button
    [variant]="button.style || 'default'"
    [label]="button.label"
    [loading]="!!button.loading"
    [disabled]="!!button.disabled"
    (clicked)="onButton(button)">
  </app-sb-button>
  }
</div>
}
